import { useQuery } from '@tanstack/react-query';

import { useRequestConstructor } from '../../../hooks/useRequestConstructor';
import { unwrapNonPaginatedResponseDataAs } from '../../../logic/unwrapNonPaginatedResponseDataAs';
import { DOCUMENTS_BASE_PATH } from '../../constants/documentsBasePath';
import { getDocumentStatuses } from '../../requests/getDocumentStatuses';

export const useDocumentStatuses = (
  documentId: string,
  definitionName: string,
  statusDefinitionName: string,
  options?: { enabled?: boolean },
) => {
  const { constructGet } = useRequestConstructor();

  const { data, refetch, ...rest } = useQuery<
    Awaited<ReturnType<typeof getDocumentStatuses>>
  >({
    queryKey: [DOCUMENTS_BASE_PATH, documentId, 'status', statusDefinitionName],
    queryFn: () =>
      getDocumentStatuses(
        constructGet,
        documentId,
        definitionName,
        statusDefinitionName,
      ),
    enabled: Boolean(documentId) && (options?.enabled ?? true),
  });

  return {
    ...unwrapNonPaginatedResponseDataAs(data, refetch, 'documentStatuses'),
    ...rest,
  };
};
